import { render, staticRenderFns } from "./SectionHowToBecome.vue?vue&type=template&id=f78bb264&"
import script from "./SectionHowToBecome.vue?vue&type=script&lang=js&"
export * from "./SectionHowToBecome.vue?vue&type=script&lang=js&"
import style0 from "./SectionHowToBecome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports